import React, { useState, useEffect } from 'react';
import api from "../../../../services/api";
import BootstrapTable from "react-bootstrap-table-next";
import ToolkitProvider from "react-bootstrap-table2-toolkit";
import {
  Input,
  Button,
  Row,
  Col,
  InputGroup,
  InputGroupAddon,
  FormGroup,
  Modal,
  Label
} from "reactstrap";

export default ({ notify, empresa, title, isActive, setHeaderExtra, setOnNovo, ...props }) => {
  const [marcacoes, setMarcacoes] = useState([]);
  const [marcacao, setMarcacao] = useState(null);
  const [aplicacao, setAplicacao] = useState("O");
  const [alert, setAlert] = useState(null);

  const [columns, setColumns] = useState([
    {
      dataField: 'acoes',
      formatter: (cell, row) => acoesFormatter(cell, row)
    },
    {
      dataField: 'marcacao',
      text: title,
      sort: true
    },
    {
      dataField: 'aplicacao',
      text: 'Aplicação',
      sort: true,
      formatter: (cell) => {
        switch (cell) {
          case "C":
            return "Cliente";
          case "P":
            return "Publicação";
          case "O":
            return "Oportunidade";
          default:
            return cell || "-";
        }
      }
    }
  ]);

  useEffect(() => {
    if (isActive && setHeaderExtra) {
      setHeaderExtra(
        <FormGroup className="mb-0 ml-2">
          <Input
            type="select"
            value={aplicacao}
            onChange={(e) => setAplicacao(e.target.value)}
            size="sm"
            style={{ width: '150px' }}
          >
            <option value="C">Cliente</option>
            <option value="P">Publicação</option>
            <option value="O">Oportunidade</option>
          </Input>
        </FormGroup>
      );
      return () => setHeaderExtra(null);
    }
  }, [isActive, setHeaderExtra, aplicacao]);

  useEffect(() => {
    if (isActive && setOnNovo) {
      setOnNovo(() => () => handleAddMarcacao());
      return () => setOnNovo(null);
    }
  }, [isActive, setOnNovo, marcacao, aplicacao]); // dependency on marcacao is needed to capture the current state in the closure

  useEffect(() => {
    if (marcacoes.length === 0) loadMarcacoes();
  }, [aplicacao]); // recarregar sempre que trocar a aplicação

  async function removeMarcacao(marcacaoId) {
    try {
      await api.delete(`/common/empresas/${empresa.id}/marcacoes-padroes/${marcacaoId}`);
      loadMarcacoes();
      notify('success', 'Marcação removida');
    } catch (error) {
      console.log(error);
      notify('danger', 'Não foi possível remover marcação');
    }
    setAlert(null);
  }

  function handleRemoverMarcacao(marcacao) {
    confirmAlert(
      `Deseja realmente remover ${marcacao.marcacao} da empresa ${empresa.nome}?`,
      'danger',
      () => removeMarcacao(marcacao.id)
    );
  }

  function handleAddMarcacao() {
    if (!marcacao) {
      return;
    }
    confirmAlert(
      `Deseja realmente adicionar está marcação à ${empresa.nome}?`,
      'warning',
      () => addMarcacao()
    );
  }

  async function addMarcacao() {
    try {
      await api.post(`/common/empresas/${empresa.id}/marcacoes-padroes/`, {
        marcacao,
        aplicacao
      });
      setMarcacao(null);
      loadMarcacoes();
      notify('success', 'Marcação adicionada');
    } catch (error) {
      console.log(error);
      notify('danger', 'Não foi possível adicionar marcação');
    }
    setAlert(null);
  }

  function confirmAlert(message, alertColor, onConfirm) {
    setAlert(
      <Modal
        className={`modal-dialog-centered modal-${alertColor}`}
        contentClassName={`bg-gradient-${alertColor}`}
        isOpen={true}
        toggle={() => setAlert(null)}
      >
        <div className="modal-header">
          <h6 className="modal-title" id="modal-title-notification">
            Atenção
          </h6>
          <button
            aria-label="Close"
            className="close"
            data-dismiss="modal"
            type="button"
            onClick={() => setAlert(null)}
          >
            <span aria-hidden={true}>×</span>
          </button>
        </div>
        <div className="modal-body">
          <div className="py-3 text-center">
            <i className="fas fa-question-circle ni-3x" />
            <br />
            <br />
            <p>{message}</p>
          </div>
        </div>
        <div className="modal-footer">
          <Button className="btn-white" color="default" type="button" onClick={onConfirm}>
            Sim
          </Button>
          <Button
            className="text-white ml-auto"
            color="link"
            data-dismiss="modal"
            type="button"
            onClick={() => setAlert(null)}
          >
            Fechar
          </Button>
        </div>
      </Modal>
    );
  }

  function acoesFormatter(cell, row) {
    return (
      <div className="btn-group" role="group" aria-label="Basic example">
        <Button
          className="btn-sm"
          color="danger"
          onClick={() => handleRemoverMarcacao(row)}
          outline
        >
          <i className="fas fa-trash"></i>
        </Button>
      </div>
    );
  }

  async function loadMarcacoes() {
    try {
      const response = await api.get(`/common/empresas/${empresa.id}/marcacoes-padroes`, {
      });
      if (response.data) {
        setMarcacoes(response.data);
      }
    } catch (error) {
      console.log(error);
      notify('danger', 'Não foi possível carregar as marcações');
    }
  }

  function handleInputEnter(e) {
    if (e.key === 'Enter') {
      handleAddMarcacao();
    }
  }

  return (
    <>
      {alert}
      {!setHeaderExtra && (
        <div style={{ display: 'flex', width: '100%', justifyContent: 'center' }}>
          <Row style={{ width: '100%', maxWidth: '700px' }}>
            <Col md={3}>
              <FormGroup>
                <Label className="form-control-label">Aplicação</Label>
                <Input
                  type="select"
                  value={aplicacao}
                  onChange={(e) => setAplicacao(e.target.value)}
                  size="sm"
                >
                  <option value="C">Cliente</option>
                  <option value="P">Publicação</option>
                  <option value="O">Oportunidade</option>
                </Input>
              </FormGroup>
            </Col>
            <Col md={9}>
              <FormGroup>
                <label className="form-control-label">{title}</label>
                <InputGroup className="mb-3">
                  <div style={{ display: 'flex', width: '100%' }}>
                    <Input
                      className="form-control"
                      placeholder={`${title}...`}
                      onChange={(e) => setMarcacao(e.target.value)}
                      value={marcacao}
                      onKeyDown={handleInputEnter}
                      size="sm"
                    />
                    <InputGroupAddon addonType="append">
                      <Button
                        color="primary"
                        type="button"
                        outline
                        onClick={handleAddMarcacao}
                        className="btn-icon btn-3"
                        size="sm"
                        style={{ whiteSpace: 'nowrap' }}
                      >
                        <span className="btn-inner--icon">
                          <i className="ni ni-fat-add"></i>
                        </span>
                        <span className="btn-inner--text">Adicionar {title}</span>
                      </Button>
                    </InputGroupAddon>
                  </div>
                </InputGroup>
              </FormGroup>
            </Col>
          </Row>
        </div>
      )}
      {setHeaderExtra && (
        <div className="mb-3">
          <Input
            className="form-control"
            placeholder={`Digite o nome da ${title} e clique em Novo...`}
            onChange={(e) => setMarcacao(e.target.value)}
            value={marcacao}
            onKeyDown={handleInputEnter}
          />
        </div>
      )}
      <Row>
        <Col>
          <ToolkitProvider data={marcacoes} keyField="id" columns={columns} search>
            {props => (
              <div className="py-4">
                <BootstrapTable
                  {...props.baseProps}
                  bootstrap4={true}
                  bordered={false}
                />
              </div>
            )}
          </ToolkitProvider>
        </Col>
      </Row>
    </>
  );
};
